/**
 * @desc: - 导航菜单
 * @param  {[OBJECT]} row     [userMenu 子集]
 * @author: klaf
 *   MINI:
 *  <div className="warpBg pannel-game-container">
 <div className="warp">
 <div className="topNav">
 <div className="logo left">
 <a href="/#">杏彩娱乐</a>
 </div>
 <div className="left nav navList gameNav">
 <ul>
 {
                USER_MENUS.map((row, index) => {
                  return <NavigationMenu key={index} row={row} type="2" />
                })
              }
 </ul>
 </div>
 </div>
 </div>
 </div>
 */
import React from 'react';

export default class NavigationMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      isActive: this.props.isActive
    }
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.click = this.click.bind(this);
  }

  // 鼠标移入
  handleMouseOver(p) {
    if (p.currentTarget.className.indexOf('actived') > -1) {
      return;
    }
    p.currentTarget.className = p.currentTarget.className + ' actived';
  }

  // 鼠标移出
  handleMouseLeave(p) {
    if (p.currentTarget.className.indexOf(' actived') > -1) {
      p.currentTarget.className = p.currentTarget.className.replace(' actived', '');
    }
    if (p.currentTarget.className.indexOf('actived') > -1) {
      p.currentTarget.className = p.currentTarget.className.replace('actived', '');
    }
    return;
  }

  handleClick(url, target) {
    if (!url) {
      return;
    }
    if (target == '_blank') {
      window.open(url)
    } else {
      window.location.href = url;
    }
  }

  click(url) {
    if (url != '') {
      window.location.href = url;
    }

    if (this.props.click) {
      this.props.click(this.props.index);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isActive: nextProps.isActive
    })
  }

  render() {
    const {type, row} = this.props;
    const {isActive} = this.state;
    // type='2' 游戏页的menu
    // type='1'或者为空 首页的menu
    if (type == '2' || type == '3' || type == '4') {
      return <li className={row.gamePageClassName + (isActive ? " active" : "")} onMouseOver={this.handleMouseOver}
                 onMouseLeave={this.handleMouseLeave}>
        <div className={(this.props.active && false ? "active " : "") + " item"}>
          <a onClick={() => this.click(row.url)} href={row.url == '' ? 'javascript:void(0);' : row.url}>{row.cnName}</a>
          {row.relatedGame}
        </div>

      </li>
    } else {
      return <li className={(row.className == '' ? 'pannel-li' : row.className) + (isActive ? " active" : "")}
                 onMouseOver={this.handleMouseOver}
                 onMouseLeave={this.handleMouseLeave}
      >
        <div className={" item"} onClick={this.handleClick.bind(this, row.url, row.target)}>
          <a target={row.target} onClick={() => this.click(row.enName == "Team" ? "" : row.url)}
             href='javascript:void(0)'
             className={row.hrefClassName == '' ? 'pannel-common' : 'pannel-common ' + row.hrefClassName}>
            {row.emClassName == '' ? '' : <em className={row.emClassName}></em>}
            {row.iClassName == '' ? '' : <i className={row.iClassName}></i>}
            <b>{row.cnName}</b>

          </a>

        </div>
        {row.related}
      </li>
    }

  }
}
